module.exports = __webpack_public_path__ + "static/media/logo.568f121e.svg";